import React, { Component } from "react";
// import { DatePicker } from "rsuite";
import TextField from '@material-ui/core/TextField';
import Axios from "axios";
import PublishSharpIcon from '@material-ui/icons/PublishSharp';
import PublishOutlinedIcon from '@material-ui/icons/PublishOutlined';
import KeyboardBackspaceSharpIcon from '@material-ui/icons/KeyboardBackspaceSharp';
import LinearProgress from '@material-ui/core/LinearProgress';
import KenTable from '../../global_components/KenTable/kentable';
import KenPaginationUI from '../../global_components/KenPaginator';
import KenContainerNavbar from '../../global_components/KenContainerNav';
// import Loader from '../../../utils/loader/loaders';
import Button from '@material-ui/core/Button';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import RemoveCircleOutlineIcon from '@material-ui/icons/RemoveCircleOutline';
import IconButton from '@material-ui/core/IconButton';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import "./index.scss";
const userDetails = require('./userdetails.json');
function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}
class MyInvestment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      env: JSON.parse(localStorage.getItem('env')),
      authToken: localStorage.getItem("auth_token"),
      instituteId: localStorage.getItem('instituteId'),
      loginEmail: localStorage.getItem('channel'),
      orgId: localStorage.getItem('orgId'),
      showUploadDoc: false,
      upload: false,
      isPortal: false,
      fileSize: '',
      pdfLoaded: 0,
      processLoaded: 0,
      status: "Pending",
      userDetails: userDetails,
      investmentDeclarationForm: {
        date: new Date(),
        permanentAc: localStorage.getItem('userDetails') != undefined ? JSON.parse(localStorage.getItem('userDetails')).PAN != undefined ? JSON.parse(localStorage.getItem('userDetails')).PAN : "" : ""
      },
      page: 1,
      limit: 10,
      totalRecord: 0,
      totalPages: 0,
      containerNav: {
        isBack: true,
        name: 'List of Investment Declaration',
        isName: false,
        isSearch: false,
        isSort: false,
        isPrint: false,
        isDownload: false,
        isShare: false,
        isNew: true,
        newName: "New",
        isSubmit: false
      },
      tableView: true,
      investmentDeclarationData: [],
      declarationCheck: true,
      otherIncomeCheck: true,
      otherIncomeDetails: {
        "Bank Interest": [{
          declaration: 'Fixed Deposit',
          declarationAmount: ''
        }, {
          declaration: 'Other Income',
          declarationAmount: ''
        }],
        "Rental Income": [{
          declaration: 'House/Property',
          declarationAmount: ''
        }],
        "Capital Gain": [{
          declaration: '',
          declarationAmount: ''
        }],
        "Previous Employement": [{
          declaration: 'Previous Employement',
          declarationAmount: ''
        }]
      },
      eightyCDetails: [{
        declaration: 'Life Insurance Premium(LIC)',
        declarationAmount: ''
      }, { "declaration": "Provident Fund(PF)", "declarationAmount": "" }, { "declaration": "Public Provident Fund(PPF)", "declarationAmount": "" }, { "declaration": "Voluntary Provident Fund(VPF)", "declarationAmount": "" }, { "declaration": "National Savings Certificate(NSC)", "declarationAmount": "" }, { "declaration": "Interest accrued on NSC(Re-invested)", "declarationAmount": "" }, { "declaration": "Unit Linked Insurance Policy(ULIP)", "declarationAmount": "" }, { "declaration": "Equity Linked Savings Scheme(ELSS)-Mutual Fund", "declarationAmount": "" }, { "declaration": "Payment for Tuition Fees for Children(Max. 2 Children)", "declarationAmount": "" }, { "declaration": "Principal Repayment Of Housing Loan", "declarationAmount": "" }, { "declaration": "Stamp Duty, Registration charges incurred for Buying", "declarationAmount": "" }, { "declaration": "House(1st Year Only)", "declarationAmount": "" }, { "declaration": "Infrastructure Bonds", "declarationAmount": "" }, { "declaration": "Bank Fixed Deposit For 5 Years & Above", "declarationAmount": "" }, { "declaration": "Post Office Term Deposit For 5 Years & Above", "declarationAmount": "" }, { "declaration": "Senior Citizen Savings Scheme", "declarationAmount": "" }, { "declaration": "Sukanya Samriddhi Account Scheme", "declarationAmount": "" }, { "declaration": "Others", "declarationAmount": "" }],
      eightyDetails: [
        {
          "declaration": "Medical Insurance Premium-Individual, Spouse & Children ",
          "declarationAmount": "",
          "section": "80D",
          "type": "1"
        },
        {
          "declaration": "Medical Insurance Premium-Parents below 60 Years",
          "declarationAmount": "",
          "section": "80D",
          "type": "2"
        },
        {
          "declaration": "Medical Insurance Premium-Parents above 60 Years",
          "declarationAmount": "",
          "section": "80D",
          "type": "3"
        },
        {
          "declaration": "Preventive Health Check-up",
          "declarationAmount": "",
          "section": "80D",
          "type": "4"
        },
        {
          "declaration": "80DD",
          "declarationAmount": "",
          "section": "80DD"
        },
        {
          "declaration": "80DDB",
          "declarationAmount": "",
          "section": "80DDB"
        },
        {
          "declaration": "Interest for Loan taken for Higher Education",
          "declarationAmount": "",
          "section": "80E"
        },
        {
          "declaration": "Deduction in respect of interest on deposits in saving account",
          "declarationAmount": "",
          "section": "80TTA"
        },
        {
          "declaration": "Others",
          "declarationAmount": "",
          "section": " "
        }
      ],
      snackbar: { openNotification: false, NotificationMessage: "", status: "success" },
      investmentDeclarationStatus: "applied",
      uploadDocName: "",
      investmentFormData: {},
      readonlyInput: false,
      readonlyOtherInput: false,
      previewId: undefined,
      noProg: "Fetching"
    };
    this.inputFile = React.createRef(this.inputFile)
  }
  componentDidMount() {
    // Axios({
    //   url: `${this.state.env['baseUri']}/user/profile?userName=${this.state.loginEmail}`,
    //   method: 'get',
    //   data: {
    //     "authToken": this.state.auth_token
    //   }
    // }).then(res => {
    //   console.log("getUserProfile", res)
    //   let userProfile = res.data.data;
    //   if (res.data.data) {
    //     let firstName = userProfile.firstName;
    //     let lastName = (userProfile.lastName != null && userProfile.lastName != "-") ? userProfile.lastName : '';
    //     let username = firstName + ' ' + lastName
    //     localStorage.setItem('username', username)
    //     localStorage.setItem('userDetails', JSON.stringify(userProfile))
    //     let userDetails = userProfile
    //     let investmentDeclarationForm = {
    //       date: new Date(),
    //       permanentAc: userProfile.PAN != undefined ? userProfile.PAN : ""
    //     }
    //     this.setState({ userDetails: userDetails, investmentDeclarationForm: investmentDeclarationForm })
    //     this.getInvestmentDetails()
    //   }
    // }).catch(err => {
    //   this.setState({ noProg: 'No Data', configInfo: false, })
    // })
    // Axios.get(`${this.state.env['getUserProfile']}/setup/payrollsettings?instituteid=${this.state.instituteId}`, {
    //   headers: {
    //     'Authorization': this.state.authToken
    //   }
    // }).
    //   then(res => {
    //     console.log(res)
    //     if (res.data.length !== 0) {
    //       let response = res.data[0]

    //     }

    //   }).catch(err => {
    //     console.log(err)
    //     this.setState({ noProg: 'No Data', configInfo: false, })
    //   })
  }

  getInvestmentDetails = () => {
    // this.setState({
    //   isLoader: true
    // }, () => {
    //   Axios.get(`${this.state.env['zqBaseUri']}/payroll/investmentDeclaration?employeeId=${this.state.userDetails.employeeID}&page=${this.state.page}&limit=${isNaN(this.state.limit) ? 10 : this.state.limit}`, {
    //     headers: {
    //       "Content-Type": "application/json",
    //       'Authorization': this.state.authToken
    //     }
    //   }).
    //     then(res => {
    //       if (res.data.data != undefined) {
    //         let response = res.data.data
    //         let investmentDeclarationData = []
    //         response.map(item => {
    //           investmentDeclarationData.push({
    //             "Financial Year": item.financialYear,
    //             "Total Income": this.formatCurrency(item.totalIncomeAmount),
    //             "Total Investment": this.formatCurrency(item.totalDeclarationAmount),
    //             "Status": item.status.toLowerCase() == "applied" ? "Declared" : item.status,
    //             "Item": JSON.stringify(item)
    //           })
    //         })
    //         this.resetComponent()
    //         this.setState({ investmentDeclarationData: [], noProg: "No Data" }, () => {
    //           this.setState({
    //             investmentDeclarationData: investmentDeclarationData,
    //             loader: false,
    //             totalRecord: res.data.totalRecord,
    //             totalPages: res.data.totalPage,
    //             page: Number(res.data.currentPage),
    //             limit: Number(res.data.limit)
    //           })
    //         })

    //       }
    //     }).catch(err => {
    //       console.log(err)
    //       this.setState({
    //         noProg: 'No Data', configInfo: false,
    //         loader: false
    //       })
    //     }
    //     )

    // })
  }
  resetComponent = () => {
    this.setState({
      tableView: true,
      declarationCheck: true,
      otherIncomeCheck: true,
      otherIncomeDetails: {
        "Bank Interest": [{
          declaration: 'Fixed Deposit',
          declarationAmount: ''
        }, {
          declaration: 'Other Income',
          declarationAmount: ''
        }],
        "Rental Income": [{
          declaration: 'House/Property',
          declarationAmount: ''
        }],
        "Capital Gain": [{
          declaration: '',
          declarationAmount: ''
        }],
        "Previous Employement": [{
          declaration: 'Previous Employement',
          declarationAmount: ''
        }]
      },
      eightyCDetails: [{
        declaration: 'Life Insurance Premium(LIC)',
        declarationAmount: ''
      }, { "declaration": "Provident Fund(PF)", "declarationAmount": "" }, { "declaration": "Public Provident Fund(PPF)", "declarationAmount": "" }, { "declaration": "Voluntary Provident Fund(VPF)", "declarationAmount": "" }, { "declaration": "National Savings Certificate(NSC)", "declarationAmount": "" }, { "declaration": "Interest accrued on NSC(Re-invested)", "declarationAmount": "" }, { "declaration": "Unit Linked Insurance Policy(ULIP)", "declarationAmount": "" }, { "declaration": "Equity Linked Savings Scheme(ELSS)-Mutual Fund", "declarationAmount": "" }, { "declaration": "Payment for Tuition Fees for Children(Max. 2 Children)", "declarationAmount": "" }, { "declaration": "Principal Repayment Of Housing Loan", "declarationAmount": "" }, { "declaration": "Stamp Duty, Registration charges incurred for Buying", "declarationAmount": "" }, { "declaration": "House(1st Year Only)", "declarationAmount": "" }, { "declaration": "Infrastructure Bonds", "declarationAmount": "" }, { "declaration": "Bank Fixed Deposit For 5 Years & Above", "declarationAmount": "" }, { "declaration": "Post Office Term Deposit For 5 Years & Above", "declarationAmount": "" }, { "declaration": "Senior Citizen Savings Scheme", "declarationAmount": "" }, { "declaration": "Sukanya Samriddhi Account Scheme", "declarationAmount": "" }, { "declaration": "Others", "declarationAmount": "" }],
      eightyDetails: [
        {
          "declaration": "Medical Insurance Premium-Individual, Spouse & Children ",
          "declarationAmount": "",
          "section": "80D",
          "type": "1"
        },
        {
          "declaration": "Medical Insurance Premium-Parents below 60 Years",
          "declarationAmount": "",
          "section": "80D",
          "type": "2"
        },
        {
          "declaration": "Medical Insurance Premium-Parents above 60 Years",
          "declarationAmount": "",
          "section": "80D",
          "type": "3"
        },
        {
          "declaration": "Preventive Health Check-up",
          "declarationAmount": "",
          "section": "80D",
          "type": "4"
        },
        {
          "declaration": "80DD",
          "declarationAmount": "",
          "section": "80DD"
        },
        {
          "declaration": "80DDB",
          "declarationAmount": "",
          "section": "80DDB"
        },
        {
          "declaration": "Interest for Loan taken for Higher Education",
          "declarationAmount": "",
          "section": "80E"
        },
        {
          "declaration": "Deduction in respect of interest on deposits in saving account",
          "declarationAmount": "",
          "section": "80TTA"
        },
        {
          "declaration": "Others",
          "declarationAmount": "",
          "section": " "
        }
      ],
      snackbar: { openNotification: false, NotificationMessage: "", status: "success" },
      investmentDeclarationStatus: "applied",
      uploadDocName: "",
      investmentFormData: {},
      previewId: undefined
    })
  }
  formatCurrency = (amount) => {
    return (new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(amount))
  }

  showUploadUI = (name) => {
    this.setState({ showUploadDoc: true, uploadDocName: name });
  }
  bytesToSize(bytes) {
    var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    if (bytes == 0) return '0 Byte';
    var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
    this.setState({ fileSize: Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i] })
  }
  fileSelected = (ev, i) => {
    let file = ev.target.files
    let formData = new FormData()
    formData.append('file', file[0])
    console.log('file', formData)
    this.setState({ pdfLoaded: 10 })
    this.setState({ filename: file[0].name, upload: true, attachmentFileData: ev.target.files[0] }, () => {
      // this.onLoad(0)
      this.setState({ pdfLoaded: 25 })
      let investmentFormData = this.state.investmentFormData
      investmentFormData[this.state.uploadDocName] = investmentFormData[this.state.uploadDocName] == undefined ? [] : investmentFormData[this.state.uploadDocName]
      let sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
      let bytes = file[0]['size']
      if (bytes == 0) return '0 Byte';
      var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
      investmentFormData[this.state.uploadDocName].push({
        file: file[0],
        name: file[0].name,
        size: Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i]
      })

      this.setState({ pdfName: file[0].name, pdfLoaded: 100, processLoaded: 100, investmentFormData }, () => {
        console.log(this.state.investmentFormData)
      })
    })
  }
  investmentDeclHandleBack = () => {
    this.setState({ otherIncomeCheck: true });
  }
  onChangeInvestmentForm = (e) => {
    e.preventDefault();
    let investmentDeclarationForm = this.state.investmentDeclarationForm
    investmentDeclarationForm[e.target.name] = e.target.value
    this.setState({ investmentDeclarationForm: investmentDeclarationForm })
  }
  onInvestmentSubmission = () => {
    console.log('***investmentDeclarationForm***', this.state.investmentDeclarationForm)
    console.log('***otherinvestmentDeclarationForm***', this.state.otherIncomeDetails)
    let payload = {
      otherIncomeDetails: this.state.otherIncomeDetails,
      ...this.state.investmentDeclarationForm,
      eightyCDetails: this.state.eightyCDetails,
      eightyDetails: this.state.eightyDetails,
      employeeId: this.state.userDetails.employeeID,
      designation: this.state.userDetails.designation,
      department: this.state.userDetails.department,
      fullName: `${this.state.userDetails.firstName != undefined ? this.state.userDetails.firstName : null} ${this.state.userDetails.lastName != undefined ? this.state.userDetails.lastName == "-" ? "" : this.state.userDetails.lastName : null}`,
      joiningDate: this.state.userDetails.joiningDate
    }
    console.log('***payload***', JSON.stringify(payload))
    console.log('investmentFormData', this.state.investmentFormData)
    let proofLists = Object.keys(this.state.investmentFormData)
    if (this.state.investmentDeclarationStatus == "approved" && proofLists.length == 0) {
      this.setState({ snackbar: { openNotification: true, NotificationMessage: "Already your investment declaration form approved. You can not able to change the investment declaration.", status: "info" } }, () => {
        setTimeout(() => {
          this.setState({ snackbar: { openNotification: false } })
        }, 1500);
      })
    } else {
      let investmentFormData = this.state.investmentFormData

      this.setState({ loader: true }, () => {
        if (proofLists.length > 0) {
          proofLists.map((proofKey, proofKeyIndex) => {
            let proofs = this.state.investmentFormData[proofKey]
            proofs.map((proof, proofIndex) => {
              let fd = new FormData();
              fd.append('file', proof.file)
              Axios.post(`${this.state.env['zqBaseUri']}/payroll/investmentDeclarationAttachment/${this.state.userDetails.employeeID}`, fd, {
                headers: {
                  "Content-Type": "multipart/form-data",
                  'Authorization': this.state.authToken
                }
              }).
                then(res => {
                  console.log(res)
                  investmentFormData[proofKey][proofIndex]['url'] = res.data
                  investmentFormData[proofKey][proofIndex]['status'] = "Done"
                  if (proofLists.length == (proofKeyIndex + 1) && proofs.length == (proofIndex + 1)) {
                    this.setState({ investmentFormData }, () => {
                      console.log("final", this.state.investmentFormData)
                      payload['investmentFormData'] = this.state.investmentFormData
                      payload['status'] = "proof applied"
                      payload['_id'] = this.state.previewId
                      if (this.state.previewId != undefined) {
                        Axios.put(`${this.state.env['zqBaseUri']}/payroll/investmentDeclaration?id=${this.state.previewId}`, payload, {
                          headers: {
                            "Content-Type": "application/json",
                            'Authorization': this.state.authToken
                          }
                        }).
                          then(res => {
                            console.log(res)
                            this.getInvestmentDetails()

                          }).catch(err => {
                            console.log(err)
                            this.getInvestmentDetails()
                          })
                      } else {
                        Axios.post(`${this.state.env['zqBaseUri']}/payroll/investmentDeclaration`, payload, {
                          headers: {
                            "Content-Type": "application/json",
                            'Authorization': this.state.authToken
                          }
                        }).
                          then(res => {
                            console.log(res)
                            this.getInvestmentDetails()

                          }).catch(err => {
                            console.log(err)
                            this.getInvestmentDetails()
                          })
                      }

                    })

                  }

                }).catch(err => {
                  console.log(err)
                  this.setState({ noProg: 'No Data', configInfo: false, loader: true })
                }
                )
            })
          })

        } else {
          if (this.state.previewId != undefined) {
            Axios.put(`${this.state.env['zqBaseUri']}/payroll/investmentDeclaration?id=${this.state.previewId}&redeclare=true`, payload, {
              headers: {
                "Content-Type": "application/json",
                'Authorization': this.state.authToken
              }
            }).
              then(res => {
                console.log(res)
                this.getInvestmentDetails()

              }).catch(err => {
                console.log(err)
                this.getInvestmentDetails()
              })
          } else {
            Axios.post(`${this.state.env['zqBaseUri']}/payroll/investmentDeclaration`, payload, {
              headers: {
                "Content-Type": "application/json",
                'Authorization': this.state.authToken
              }
            }).
              then(res => {
                console.log(res)
                this.getInvestmentDetails()

              }).catch(err => {
                console.log(err)
                this.getInvestmentDetails()
              })
          }
        }

      })
    }
  }
  onAddInvestmentDeclaration = () => {
    this.setState({ tableView: false })
  }
  onPreviewLeavesInvestmentDeclaration = (item) => {
    console.log(item)
    let items = JSON.parse(item.Item)
    let investmentDetails = JSON.parse(items.investmentDetails)
    let investmentDeclarationForm = investmentDetails
    this.setState({ ...investmentDetails, readonlyInput: true, readonlyOtherInput: true, investmentDeclarationForm: investmentDeclarationForm, investmentDeclarationStatus: String(item.Status).toLowerCase(), previewId: items._id, investmentFormData: investmentDeclarationForm.investmentFormData != undefined ? investmentDeclarationForm.investmentFormData : {} }, () => {
      this.setState({ declarationCheck: false, tableView: false })
    })
  }
  onCheckOtherDeclaration = (params) => {
    console.log('params', params)
    this.setState({ otherIncomeCheck: params }, () => {
      this.setState({ declarationCheck: false })
    })
  }
  otherIncomeHandleBack = () => {
    this.setState({ tableView: true }, () => {
      this.setState({
        declarationCheck: true, otherIncomeDetails: {
          "Bank Interest": [{
            declaration: 'Fixed Deposit',
            declarationAmount: ''
          }, {
            declaration: 'Other Income',
            declarationAmount: ''
          }],
          "Rental Income": [{
            declaration: 'House/Property',
            declarationAmount: ''
          }],
          "Capital Gain": [{
            declaration: '',
            declarationAmount: ''
          }],
          "Previous Employement": [{
            declaration: 'Previous Employement',
            declarationAmount: ''
          }]
        }
      })
    })
  }
  onTableRowAction = (item, itemIndex, key, parentKey) => {
    console.log(item)
    console.log(itemIndex)
    if (key == 'add') {
      let otherIncomeDetails = this.state.otherIncomeDetails
      otherIncomeDetails[parentKey].push({
        declaration: '',
        declarationAmount: ''
      })
      this.setState({ otherIncomeDetails: {} }, () => {
        this.setState({ otherIncomeDetails })
      })
    } else {
      let otherIncomeDetails = {};

      Object.keys(this.state.otherIncomeDetails).map(objKey => {
        otherIncomeDetails[objKey] = []
        this.state.otherIncomeDetails[objKey].map((item, i) => {
          if (parentKey == objKey) {
            if (this.state.otherIncomeDetails[objKey].length > 1) {
              if (itemIndex != i) {
                otherIncomeDetails[objKey].push(item)
              }
            } else {
              otherIncomeDetails[objKey].push(item)
            }
          }
          else {
            otherIncomeDetails[objKey].push(item)
          }
        })
      })

      this.setState({ otherIncomeDetails: {} }, () => {
        this.setState({ otherIncomeDetails })
      })
    }
  }
  onTableColInputChanges = (e, item, itemIndex, key, parentKey) => {
    console.log(e.target.value)
    console.log(item)
    console.log(itemIndex)
    let otherIncomeDetails = this.state.otherIncomeDetails
    otherIncomeDetails[parentKey][itemIndex][key] = e.target.value
    this.setState({ otherIncomeDetails: {} }, () => {
      this.setState({ otherIncomeDetails })
    })
  }
  onOtherInvestmentSubmission = () => {
    this.setState({ otherIncomeCheck: false })
  }
  onChangeDeclarationForm = (e, ecIndex, key, parentKey) => {
    let data = this.state[parentKey]
    console.log('data', data)
    data[ecIndex][key] = e.target.value
    this.setState({ [parentKey]: [] }, () => {
      this.setState({ [parentKey]: data }, () => {
        console.log(this.state[parentKey])
      })
    })
  }
  onDeclarationRowAction = (ecIndex, action, key) => {
    if (action == "add") {
      let data = this.state[key]
      data.push({
        declaration: '',
        declarationAmount: ''
      })

      this.setState({ [key]: [] }, () => {
        this.setState({ [key]: data }, () => {
          console.log(this.state[key])
        })
      })
    } else {
      let data = []
      if (this.state[key].length > 1) {
        this.state[key].map((item, i) => {
          if (ecIndex != i) {
            data.push(item)
          }
        })
        this.setState({ [key]: [] }, () => {
          this.setState({ [key]: data })
          console.log(this.state[key])
        })
      }
    }
  }
  onInvestmentProofPwd = (e) => {
    let investmentFormData = this.state.investmentFormData
    investmentFormData[this.state.uploadDocName][investmentFormData[this.state.uploadDocName].length - 1]['password'] = e.target.value
    this.setState({ investmentFormData })
  }
  onProofSubmission = () => {
    this.setState({ showUploadDoc: false, pdfLoaded: 0, processLoaded: 0, upload: false })
  }
  onDocDownload = (url) => {
    this.setState({
      loader: true
    }, () => {
      Axios.get(`${this.state.env['zqBaseUri']}/payroll/investmentDeclarationAttachmentDownload?url=${url}`, {
        headers: {
          'Authorization': this.state.authToken
        }
      }).then(res => {
        console.log(res)
        window.open(res.data)
        this.setState({
          loader: false
        })
      }).catch(err => {
        console.log(err)
      })
    })
  }
  onInvestmentEdit = () => {
    this.setState({ readonlyInput: false })
  }
  onInvestmentOterEdit = () => {
    this.setState({ readonlyOtherInput: false })
  }
  render() {
    const onButtonClick = () => {
      if (this.state.pdfLoaded == 0) {
        this.inputFile.current.click();
      }
    };
    const { filename } = this.state;
    const layout = [{ key: 'test', x: 0, y: 0, width: 200, height: 100, zIndex: 1 }]

    const canResizable = (isResize) => {
      return { top: isResize, right: isResize, bottom: isResize, left: isResize, topRight: isResize, bottomRight: isResize, bottomLeft: isResize, topLeft: isResize };
    };
    return (
      <React.Fragment>
        {/* {this.state.loader ? <Loader /> : null} */}
        {this.state.tableView ? <React.Fragment>
          {this.state.containerNav == undefined ? null : (
            <React.Fragment>
              <KenContainerNavbar
                containerNav={this.state.containerNav}
                onAddNew={() => {
                  this.onAddInvestmentDeclaration();
                }}
              />
              <div className="print-time">{this.state.printTime}</div>
            </React.Fragment>

          )}
          {/* <div className="trial-balance-header-title">
            <KeyboardBackspaceSharpIcon className="keyboard-back-icon" onClick={() => { this.props.history.push('/main/dashboard') }} style={{
              marginRight: '5px',
              cursor: 'pointer',
              marginTop: '0px'
            }} />

            <p className="top-header-title" onClick={() => { this.props.history.push('/main/dashboard') }}>| My Investment</p>


          </div> */}
          <div
            className="table-wrapper"
            style={{ marginTop: "10px" }}
          >
            {this.state.investmentDeclarationData.length == 0 ?

              <p className="noprog-txt">{this.state.noProg}</p> :

              <React.Fragment>
                <div className="remove-last-child-table">
                  <KenTable
                    data={this.state.investmentDeclarationData}
                    rowClick={(item) => {
                      this.onPreviewLeavesInvestmentDeclaration(item);
                    }}
                  />
                </div>
              </React.Fragment>
            }
            <div className="setup-pagination">
              {this.state.investmentDeclarationData.length !== 0 && (
                <KenPaginationUI
                  onPaginationApi={this.onPaginationChange}
                  totalPages={this.state.totalPages}
                  limit={this.state.limit}
                  total={this.state.totalRecord}
                  currentPage={this.state.page}
                />
              )}
            </div>
          </div>
        </React.Fragment> : <React.Fragment>
          {
            this.state.declarationCheck ? <div className="onboard-wrap investment-check-wrap">
              <h6 className="onboard-header"><p>Do you have any other income to declare?</p></h6>
              <div className="add-acc">
                <Button className="CoaReviewBackBtn" onClick={() => this.onCheckOtherDeclaration(false)}> No </Button>
                <Button className="CoaReviewNextBtn" onClick={() => this.onCheckOtherDeclaration(true)}>Yes </Button>
              </div>
            </div> : <React.Fragment>
              {this.state.otherIncomeCheck ? <React.Fragment>
                <div className="dashboard-wrapper">
                  {/* <div className="headermenu-title">
                    <div style={{ display: "flex", zIndex: "4" }}>
                      < KeyboardBackspaceSharpIcon className="keyboard-back-icon" style={{ cursor: "pointer", width: "10%", marginLeft: "-30px" }} onClick={() => this.otherIncomeHandleBack()} />
                      <p className="overall-top-header-title">Other Income Declaration</p>
                    </div>
                  </div> */}
                  <div className="trial-balance-header-title">
                    <KeyboardBackspaceSharpIcon className="keyboard-back-icon" onClick={() => this.otherIncomeHandleBack()} style={{
                      marginRight: '5px',
                      cursor: 'pointer',
                      marginTop: '0px'
                    }} />

                    <p className="top-header-title" onClick={() => this.otherIncomeHandleBack()}>| Other Income Declaration</p>


                  </div>
                  <div className="table-wrapper investment-declaration-table">
                    {this.state.otherIncomeDetails.length === 0 ? null :
                      <React.Fragment>
                        <div className="fr-clear" style={{ marginBottom: "15px" }}>
                          <button className="add-item-btn " style={{ float: "right" }} tooltip-title={"Submit"} onClick={() => this.onOtherInvestmentSubmission()}>NEXT</button>
                          <button className="add-item-btn" style={{ float: "right", marginRight: "15px" }} tooltip-title={"Edit"} onClick={() => this.onInvestmentOterEdit()}>EDIT</button>
                        </div>
                        <table className="zq-table-wrap" style={{ background: "#fff" }}>
                          <tbody className="zq-table-body">
                            {
                              Object.keys(this.state.otherIncomeDetails).length > 0 ?
                                Object.keys(this.state.otherIncomeDetails).map((key) => {

                                  return this.state.otherIncomeDetails[key].map((item, itemIndex) => {
                                    return <>
                                      {itemIndex == 0 ? <tr key={key} className="other-income-th">
                                        <td >{key}</td>
                                        <td>&nbsp;</td>
                                        <td>&nbsp;</td>
                                        <td>&nbsp;</td>
                                      </tr> : null}
                                      <tr key={key + itemIndex}>
                                        <td>
                                          <div className="dec-form-input align-item-start other-income-input-wrap" style={{ width: "100%" }}>
                                            <div className="input-wrap" style={{ marginBottom: "0px !important" }}>
                                              <TextField disabled={this.state.readonlyOtherInput}
                                                name="id"
                                                id="id"
                                                variant="filled"
                                                type="text"
                                                defaultValue={item.declaration}
                                                onBlur={(e) => this.onTableColInputChanges(e, item, itemIndex, 'declaration', key)}>
                                              </TextField>
                                            </div>
                                          </div>
                                        </td>
                                        <td>
                                          <div className="dec-form-input align-item-start other-income-input-wrap" style={{ width: "100%" }}>
                                            <div className="input-wrap" style={{ marginBottom: "0px !important" }}>
                                              <TextField disabled={this.state.readonlyOtherInput}
                                                name="id"
                                                id="id"
                                                variant="filled"
                                                type="text"
                                                defaultValue={item.declarationAmount}
                                                onBlur={(e) => this.onTableColInputChanges(e, item, itemIndex, 'declarationAmount', key)}>
                                              </TextField>
                                            </div>
                                          </div>
                                        </td>
                                        <td>
                                          {(this.state.otherIncomeDetails[key].length == (Number(itemIndex) + 1) && this.state.investmentDeclarationStatus != "approved") ? <IconButton onClick={(e) => this.onTableRowAction(item, itemIndex, 'add', key)}>
                                            <AddCircleOutlineIcon />
                                          </IconButton> : null}
                                        </td>
                                        <td>
                                          {this.state.investmentDeclarationStatus != "approved" ? <IconButton onClick={(e) => this.onTableRowAction(item, itemIndex, 'delete', key)}> <RemoveCircleOutlineIcon />
                                          </IconButton> : null}
                                        </td>
                                      </tr>
                                    </>
                                  })
                                }) : null
                            }
                          </tbody>
                        </table>
                      </React.Fragment>}
                  </div>
                </div>
              </React.Fragment> :
                <div className="dashboard-wrapper">
                  {/* --------------Common Top Header */}
                  {/* <div className="headermenu-title">
                    <div style={{ display: "flex", zIndex: "4" }}>
                      < KeyboardBackspaceSharpIcon className="keyboard-back-icon" style={{ cursor: "pointer", width: "10%" }} onClick={this.investmentDeclHandleBack} />
                      <p className="overall-top-header-title">Investment Declaration</p>
                    </div>
                  </div> */}
                  <div className="trial-balance-header-title">
                    <KeyboardBackspaceSharpIcon className="keyboard-back-icon" onClick={this.investmentDeclHandleBack} style={{
                      marginRight: '5px',
                      cursor: 'pointer',
                      marginTop: '0px'
                    }} />

                    <p className="top-header-title" onClick={this.investmentDeclHandleBack}>| Investment Declaration</p>
                  </div>
                  {/* ------------------------------*/}
                  <div className="dashboard-header">
                    {/* Entire Form */}
                    {!this.state.showUploadDoc ?
                      <div className="dashboard-header-title">
                        {/* <div className="fr-clear">
                <button className="add-item-btn " style={{ float: "right" }} tooltip-title={"Upload"}><PublishSharpIcon className="material-addIcon" />Upload Signed Form</button>
                <button className="add-item-btn" style={{ float: "right", marginRight: "15px" }} tooltip-title={"Download"}><GetAppIcon className="material-addIcon" />Download</button>
              </div> */}
                        <div className="fr-clear">
                          <button className="add-item-btn " style={{ float: "right" }} tooltip-title={"Submit"} onClick={() => this.onInvestmentSubmission()}>SUBMIT</button>
                          <button className="add-item-btn" style={{ float: "right", marginRight: "15px" }} tooltip-title={"Edit"} onClick={() => this.onInvestmentEdit()}>EDIT</button>
                        </div>
                        <h3 className="dashboard-header-txt text-align-center">FORM NO. 12BB</h3>
                        <p className="invoice-org-address1 text-align-center">[ <i>See rule 26C</i> ]</p>
                        <p className="sub-navbar-title text-align-center">Statement showing particulars of claims by an employee for deduction of tax under section 192</p>
                        <form className="dec-form">
                          <div className="dec-form-input">
                            <div className="input-wrap">
                              <p className="input-label">1. Name of the employee<span className="mandatory">*</span></p>
                              <TextField disabled
                                name="address"
                                id="address"
                                variant="filled"
                                type="text"
                                // defaultValue={"Anand Viswanathan"}>
                                defaultValue={`${this.state.userDetails.firstName != undefined ? this.state.userDetails.firstName : null} ${this.state.userDetails.lastName != undefined ? this.state.userDetails.lastName == "-" ? "" : this.state.userDetails.lastName : null}`}
                                readOnly>
                              </TextField>
                            </div>
                          </div>
                          <div className="dec-form-input align-item-start">
                            <div className="input-wrap">
                              <p className="input-label">2. Employee ID<span className="mandatory">*</span></p>
                              <TextField disabled
                                name="id"
                                id="id"
                                variant="filled"
                                type="text"
                                defaultValue={this.state.userDetails.employeeID != undefined ? this.state.userDetails.employeeID : null}
                                readOnly>
                              </TextField>
                            </div>
                          </div>
                          <div className="dec-form-input align-item-start">
                            <div className="input-wrap">
                              <p className="input-label">3. Permanent Account Number<span className="mandatory">*</span></p>
                              <TextField disabled
                                name="permanentAc"
                                id="permanentAc"
                                variant="filled"
                                type="text"
                                value={this.state.investmentDeclarationForm.permanentAc != undefined ? this.state.investmentDeclarationForm.permanentAc : null}
                                defaultValue={this.state.investmentDeclarationForm.permanentAc != undefined ? this.state.investmentDeclarationForm.permanentAc : null}
                                onChange={(e) => this.onChangeInvestmentForm(e)}>
                              </TextField>
                            </div>
                          </div>
                          <div className="dec-form-input align-item-start">
                            <div className="input-wrap">
                              <p className="input-label">4. Financial year<span className="mandatory">*</span></p>
                              <TextField disabled={this.state.readonlyInput}
                                name="financeYear"
                                id="financeYear"
                                variant="filled"
                                type="text"
                                value={this.state.investmentDeclarationForm.financeYear != undefined ? this.state.investmentDeclarationForm.financeYear : null}
                                defaultValue={this.state.investmentDeclarationForm.financeYear != undefined ? this.state.investmentDeclarationForm.financeYear : null}
                                onChange={(e) => this.onChangeInvestmentForm(e)}>
                              </TextField>
                            </div>
                          </div>
                        </form>
                        <div className="dec-table-wrap table-wrapper">
                          <div className="remove-last-child-table">
                            <table className="zq-table-wrap" id="table-to-xls">
                              <thead className="zq-table-heading">
                                <tr>
                                  <th>Sl. No.</th>
                                  <th style={{ width: "60%" }}>Nature of claim</th>
                                  <th>Amount (Rs.)</th>
                                  <th>Proof</th>
                                  <th>Status</th>
                                </tr>
                              </thead>
                              <tbody className="zq-table-body">
                                <tr>
                                  <td rowSpan={"6"}>1</td>
                                  <td><b>House Rent Allowance:</b></td>
                                  <td>&nbsp;</td>
                                  <td>&nbsp;</td>
                                  <td>&nbsp;</td>
                                </tr>
                                <tr>
                                  <td>i. Rent paid to the landlord</td>
                                  <td>
                                    <div className="input-wrap width-30 margin0">
                                      <TextField disabled={this.state.readonlyInput}
                                        name="rent"
                                        id="rent"
                                        variant="filled"
                                        type="amount"
                                        value={this.state.investmentDeclarationForm.rent != undefined ? this.state.investmentDeclarationForm.rent : null}
                                        defaultValue={this.state.investmentDeclarationForm.rent != undefined ? this.state.investmentDeclarationForm.rent : null}
                                        onChange={(e) => this.onChangeInvestmentForm(e)}>
                                      </TextField>
                                    </div>
                                  </td>
                                  <td>
                                    {
                                      this.state.investmentFormData.rent != undefined && this.state.investmentFormData.rent.length > 0 ? <ul className="investment-doc-list-wrap">
                                        {this.state.investmentFormData.rent.map((item, i) => {
                                          return <li><span onClick={() => this.onDocDownload(item.url == undefined ? null : item.url)}>{item.name}</span> {item.url == undefined ? <span onClick={() => this.onRemoveDoc('rent', i)}>x</span> : null}</li>
                                        })}
                                      </ul> : null
                                    }
                                    <button className="add-item-btn " disabled={this.state.investmentDeclarationStatus == 'approved' ? false : true} onClick={() => this.showUploadUI('rent')} tooltip-title={"Upload"}><PublishSharpIcon className="material-addIcon" /></button></td>
                                  <td><p className={this.state.investmentFormData.rent != undefined && this.state.investmentFormData.rent.length > 0 ? "investment-status" : "investment-status-pending"}>{this.state.investmentFormData.rent != undefined && this.state.investmentFormData.rent.length > 0 ? "Done" : "Pending"}</p></td>
                                </tr>
                                <tr>
                                  <td>ii. Name of the landlord</td>
                                  <td>
                                    <div className="input-wrap width-30 margin0">
                                      <TextField disabled={this.state.readonlyInput}
                                        name="nameLard"
                                        id="nameLard"
                                        variant="filled"
                                        type="text"
                                        value={this.state.investmentDeclarationForm.nameLard != undefined ? this.state.investmentDeclarationForm.nameLard : null}
                                        defaultValue={this.state.investmentDeclarationForm.nameLard != undefined ? this.state.investmentDeclarationForm.nameLard : null}
                                        onChange={(e) => this.onChangeInvestmentForm(e)}
                                      >
                                      </TextField>
                                    </div>
                                  </td>
                                  <td>
                                    {/* <button className="add-item-btn " disabled onClick={() => this.showUploadUI('rent')} tooltip-title={"Upload"}><PublishSharpIcon className="material-addIcon" /></button> */}
                                  </td>
                                  <td>
                                    {/* <p className={this.state.status == "Done" ? "investment-status" : "investment-status-pending"}>{this.state.status}</p> */}
                                  </td>
                                </tr>

                                <tr>
                                  <td>iii. Address of the landlord</td>
                                  <td>
                                    <div className="input-wrap width-30 margin0">
                                      <TextField disabled={this.state.readonlyInput}
                                        name="addressLand"
                                        id="addressLand"
                                        variant="filled"
                                        type="text"
                                        value={this.state.investmentDeclarationForm.addressLand != undefined ? this.state.investmentDeclarationForm.addressLand : null}
                                        defaultValue={this.state.investmentDeclarationForm.addressLand != undefined ? this.state.investmentDeclarationForm.addressLand : null}
                                        onChange={(e) => this.onChangeInvestmentForm(e)}>
                                      </TextField>
                                    </div>
                                  </td>
                                  <td>
                                    {/* <button className="add-item-btn " disabled={this.state.investmentDeclarationStatus == 'approved' ? false : true} onClick={() => this.showUploadUI('leaseOrRentAmount')} tooltip-title={"Upload"}><PublishSharpIcon className="material-addIcon" /></button> */}
                                  </td>
                                  <td>
                                    {/* <p className={this.state.status == "Done" ? "investment-status" : "investment-status-pending"}>{this.state.status}</p> */}
                                  </td>
                                </tr>

                                <tr>
                                  <td>iv. [ <i>Permanent Account Number or Aadhaar Number</i> ] of the landlord</td>
                                  <td>
                                    <div className="input-wrap width-30 margin0">
                                      <TextField disabled={this.state.readonlyInput}
                                        name="landlordPAN"
                                        id="landlordPAN"
                                        variant="filled"
                                        type="text"
                                        value={this.state.investmentDeclarationForm.landlordPAN != undefined ? this.state.investmentDeclarationForm.landlordPAN : null}
                                        defaultValue={this.state.investmentDeclarationForm.landlordPAN != undefined ? this.state.investmentDeclarationForm.landlordPAN : null}
                                        onChange={(e) => this.onChangeInvestmentForm(e)}>
                                      </TextField>
                                    </div>
                                  </td>
                                  <td>
                                    {/* <button className="add-item-btn " disabled onClick={this.showUploadUI} tooltip-title={"Upload"}><PublishSharpIcon className="material-addIcon" /></button> */}
                                  </td>
                                  <td>
                                    {/* <p className={this.state.status == "Done" ? "investment-status" : "investment-status-pending"}>{this.state.status}</p> */}
                                  </td>
                                </tr>

                                <tr>
                                  <td><b>Note</b>: [ <i>Permanent Account Number or AadhaarNumber</i> ] shall be furnished if the aggregate rent paidduring the previous year exceeds one lakh rupees</td>
                                  <td>&nbsp;</td>
                                  <td>&nbsp;</td>
                                  <td></td>
                                </tr>
                                <tr>
                                  <td>2</td>
                                  <td><b>Location of property taken on lease / rent</b></td>
                                  <td>
                                    <div className="input-wrap width-30 margin0">
                                      <TextField disabled={this.state.readonlyInput}
                                        name="leaseOrRentAmount"
                                        id="leaseOrRentAmount"
                                        variant="filled"
                                        type="amount"
                                        value={this.state.investmentDeclarationForm.leaseOrRentAmount != undefined ? this.state.investmentDeclarationForm.leaseOrRentAmount : null}
                                        defaultValue={this.state.investmentDeclarationForm.leaseOrRentAmount != undefined ? this.state.investmentDeclarationForm.leaseOrRentAmount : null}
                                        onChange={(e) => this.onChangeInvestmentForm(e)}>
                                      </TextField>
                                    </div>
                                  </td>
                                  <td>
                                    {
                                      this.state.investmentFormData.leaseOrRentAmount != undefined && this.state.investmentFormData.leaseOrRentAmount.length > 0 ? <ul className="investment-doc-list-wrap">
                                        {this.state.investmentFormData.leaseOrRentAmount.map((item, i) => {
                                          return <li><span onClick={() => this.onDocDownload(item.url == undefined ? null : item.url)}>{item.name}</span> {item.url == undefined ? <span onClick={() => this.onRemoveDoc('leaseOrRentAmount', i)}>x</span> : null}</li>
                                        })}
                                      </ul> : null
                                    }
                                    <button className="add-item-btn " disabled={this.state.investmentDeclarationStatus == 'approved' ? false : true} onClick={() => this.showUploadUI('leaseOrRentAmount')} tooltip-title={"Upload"}><PublishSharpIcon className="material-addIcon" /></button></td>
                                  <td><p className={this.state.investmentFormData.leaseOrRentAmount != undefined && this.state.investmentFormData.leaseOrRentAmount.length > 0 ? "investment-status" : "investment-status-pending"}>{this.state.investmentFormData.leaseOrRentAmount != undefined && this.state.investmentFormData.leaseOrRentAmount.length > 0 ? "Done" : "Pending"}</p></td>
                                </tr>
                                <tr>
                                  <td>3</td>
                                  <td><b>DEDUCTIONS  u/s 24</b></td>
                                  <td>
                                    &nbsp;
                                  </td>
                                  <td>&nbsp;</td>
                                  <td>&nbsp;</td>
                                </tr>

                                <tr>
                                  <td></td>
                                  <td>i. Interest on Housing Loan u/s 24(If the house is Self-Occupied and the loan was taken before 1st April 1999) Bankers Certificate to be Submitted)</td>
                                  <td>
                                    <div className="input-wrap width-30 margin0">
                                      <TextField disabled={this.state.readonlyInput}
                                        name="housingLoanInterestBefore99"
                                        id="housingLoanInterestBefore99"
                                        variant="filled"
                                        type="amount"
                                        value={this.state.investmentDeclarationForm.housingLoanInterestBefore99 != undefined ? this.state.investmentDeclarationForm.housingLoanInterestBefore99 : null}
                                        defaultValue={this.state.investmentDeclarationForm.housingLoanInterestBefore99 != undefined ? this.state.investmentDeclarationForm.housingLoanInterestBefore99 : null}
                                        onChange={(e) => this.onChangeInvestmentForm(e)}>
                                      </TextField>
                                    </div>
                                  </td>
                                  <td>
                                    {
                                      this.state.investmentFormData.housingLoanInterestBefore99 != undefined && this.state.investmentFormData.housingLoanInterestBefore99.length > 0 ? <ul className="investment-doc-list-wrap">
                                        {this.state.investmentFormData.housingLoanInterestBefore99.map((item, i) => {
                                          return <li><span onClick={() => this.onDocDownload(item.url == undefined ? null : item.url)}>{item.name}</span> {item.url == undefined ? <span onClick={() => this.onRemoveDoc('housingLoanInterestBefore99', i)}>x</span> : null}</li>
                                        })}
                                      </ul> : null
                                    }
                                    <button className="add-item-btn " disabled={this.state.investmentDeclarationStatus == 'approved' ? false : true} onClick={() => this.showUploadUI('housingLoanInterestBefore99')} tooltip-title={"Upload"}><PublishSharpIcon className="material-addIcon" /></button></td>
                                  <td><p className={this.state.investmentFormData.housingLoanInterestBefore99 != undefined && this.state.investmentFormData.housingLoanInterestBefore99.length > 0 ? "investment-status" : "investment-status-pending"}>{this.state.investmentFormData.housingLoanInterestBefore99 != undefined && this.state.investmentFormData.housingLoanInterestBefore99.length > 0 ? "Done" : "Pending"}</p></td>
                                </tr>
                                <tr>
                                  <td></td>
                                  <td>ii. Interest on Housing Loan u/s 24(If the house is Self-Occupied and the loan was taken after 1st April 1999) (Bankers Certificate to be Submitted)</td>
                                  <td>
                                    <div className="input-wrap width-30 margin0">
                                      <TextField disabled={this.state.readonlyInput}
                                        name="housingLoanInterestAfter99"
                                        id="housingLoanInterestAfter99"
                                        variant="filled"
                                        type="amount"
                                        value={this.state.investmentDeclarationForm.housingLoanInterestAfter99 != undefined ? this.state.investmentDeclarationForm.housingLoanInterestAfter99 : null}
                                        defaultValue={this.state.investmentDeclarationForm.housingLoanInterestAfter99 != undefined ? this.state.investmentDeclarationForm.housingLoanInterestAfter99 : null}
                                        onChange={(e) => this.onChangeInvestmentForm(e)}>
                                      </TextField>
                                    </div>
                                  </td>
                                  <td>
                                    {
                                      this.state.investmentFormData.housingLoanInterestAfter99 != undefined && this.state.investmentFormData.housingLoanInterestAfter99.length > 0 ? <ul className="investment-doc-list-wrap">
                                        {this.state.investmentFormData.housingLoanInterestAfter99.map((item, i) => {
                                          return <li><span onClick={() => this.onDocDownload(item.url == undefined ? null : item.url)}>{item.name}</span> {item.url == undefined ? <span onClick={() => this.onRemoveDoc('housingLoanInterestAfter99', i)}>x</span> : null}</li>
                                        })}
                                      </ul> : null
                                    }
                                    <button className="add-item-btn " disabled={this.state.investmentDeclarationStatus == 'approved' ? false : true} onClick={() => this.showUploadUI('housingLoanInterestAfter99')} tooltip-title={"Upload"}><PublishSharpIcon className="material-addIcon" /></button></td>
                                  <td><p className={this.state.investmentFormData.housingLoanInterestAfter99 != undefined && this.state.investmentFormData.housingLoanInterestAfter99.length > 0 ? "investment-status" : "investment-status-pending"}>{this.state.investmentFormData.housingLoanInterestAfter99 != undefined && this.state.investmentFormData.housingLoanInterestAfter99.length > 0 ? "Done" : "Pending"}</p></td>
                                </tr>


                                <tr>
                                  <td>4</td>
                                  <td><b>SECTION 80C</b></td>
                                  <td>
                                    &nbsp;
                                  </td>
                                  <td>&nbsp;</td>
                                  <td>&nbsp;</td>
                                </tr>
                                {this.state.eightyCDetails.length > 0 ?
                                  this.state.eightyCDetails.map((ecItem, ecIndex) => {
                                    return <tr>
                                      <td>
                                      </td>
                                      <td>

                                        <div className="input-wrap merge-label-input margin0">
                                          <p className="input-label"></p>
                                          <TextField disabled={this.state.readonlyInput}
                                            name={ecItem.declaration}
                                            id={"declaration-" + ecIndex}
                                            variant="filled"
                                            type="text"
                                            defaultValue={ecItem.declaration != undefined ? ecItem.declaration : null}
                                            onBlur={(e) => this.onChangeDeclarationForm(e, ecIndex, 'declaration', 'eightyCDetails')}>
                                          </TextField>
                                        </div>
                                      </td>
                                      <td>

                                        <div className="input-wrap width-30 margin0" style={{ width: "calc(70% - 15px)", marginRight: "15px", float: "left" }}>
                                          <TextField disabled={this.state.readonlyInput}
                                            name={ecItem.declaration + ' Amount'}
                                            id={"declaration-amount-" + ecIndex}
                                            variant="filled"
                                            type="number"
                                            defaultValue={ecItem.declarationAmount != undefined ? ecItem.declarationAmount : null}
                                            onBlur={(e) => this.onChangeDeclarationForm(e, ecIndex, 'declarationAmount', 'eightyCDetails')}>
                                          </TextField>
                                        </div>
                                        {this.state.investmentDeclarationStatus != "approved" ? <div className="declaration-row-action" style={{ width: "30%", float: "left" }}>

                                          {this.state.eightyCDetails.length == (Number(ecIndex) + 1) ? <IconButton onClick={(e) => this.onDeclarationRowAction(ecIndex, 'add', "eightyCDetails")}>
                                            <AddCircleOutlineIcon />
                                          </IconButton> : null}
                                          <IconButton onClick={(e) => this.onDeclarationRowAction(ecIndex, 'delete', "eightyCDetails")}> <RemoveCircleOutlineIcon />
                                          </IconButton>
                                        </div> : null}
                                      </td>
                                      <td>
                                        {
                                          this.state.investmentFormData[ecItem.declaration] != undefined && this.state.investmentFormData[ecItem.declaration].length > 0 ? <ul className="investment-doc-list-wrap">
                                            {this.state.investmentFormData[ecItem.declaration].map((item, i) => {
                                              return <li><span onClick={() => this.onDocDownload(item.url == undefined ? null : item.url)}>{item.name}</span> {item.url == undefined ? <span onClick={() => this.onRemoveDoc(ecItem.declaration, i)}>x</span> : null}</li>
                                            })}
                                          </ul> : null
                                        }
                                        <button className="add-item-btn " disabled={this.state.investmentDeclarationStatus == 'approved' ? false : true} onClick={() => this.showUploadUI(ecItem.declaration)} tooltip-title={"Upload"}><PublishSharpIcon className="material-addIcon" /></button></td>
                                      <td><p className={this.state.investmentFormData[ecItem.declaration] != undefined && this.state.investmentFormData[ecItem.declaration].length > 0 ? "investment-status" : "investment-status-pending"}>{this.state.investmentFormData[ecItem.declaration] != undefined && this.state.investmentFormData[ecItem.declaration].length > 0 ? "Done" : "Pending"}</p></td>
                                    </tr>
                                  }) : null}

                                <tr>
                                  <td>5</td>
                                  <td><b>Deduction u/s 80CCC</b></td>
                                  <td>
                                    &nbsp;
                                  </td>
                                  <td>&nbsp;</td>
                                  <td>&nbsp;</td>
                                </tr>
                                <tr>
                                  <td></td>
                                  <td>Contribution To Certain Pension Funds</td>
                                  <td>
                                    <div className="input-wrap width-30 margin0">
                                      <TextField disabled={this.state.readonlyInput}
                                        name="eightyCCCPensionFunds"
                                        id="eightyCCCPensionFunds"
                                        variant="filled"
                                        type="amount"
                                        value={this.state.investmentDeclarationForm.eightyCCCPensionFunds != undefined ? this.state.investmentDeclarationForm.eightyCCCPensionFunds : null}
                                        defaultValue={this.state.investmentDeclarationForm.eightyCCCPensionFunds != undefined ? this.state.investmentDeclarationForm.eightyCCCPensionFunds : null}
                                        onChange={(e) => this.onChangeInvestmentForm(e)}>
                                      </TextField>
                                    </div>
                                  </td>
                                  <td>
                                    {
                                      this.state.investmentFormData.eightyCCCPensionFunds != undefined && this.state.investmentFormData.eightyCCCPensionFunds.length > 0 ? <ul className="investment-doc-list-wrap">
                                        {this.state.investmentFormData.eightyCCCPensionFunds.map((item, i) => {
                                          return <li><span onClick={() => this.onDocDownload(item.url == undefined ? null : item.url)}>{item.name}</span> {item.url == undefined ? <span onClick={() => this.onRemoveDoc('eightyCCCPensionFunds', i)}>x</span> : null}</li>
                                        })}
                                      </ul> : null
                                    }
                                    <button className="add-item-btn " disabled={this.state.investmentDeclarationStatus == 'approved' ? false : true} onClick={() => this.showUploadUI('eightyCCCPensionFunds')} tooltip-title={"Upload"}><PublishSharpIcon className="material-addIcon" /></button></td>
                                  <td><p className={this.state.investmentFormData.eightyCCCPensionFunds != undefined && this.state.investmentFormData.eightyCCCPensionFunds.length > 0 ? "investment-status" : "investment-status-pending"}>{this.state.investmentFormData.eightyCCCPensionFunds != undefined && this.state.investmentFormData.eightyCCCPensionFunds.length > 0 ? "Done" : "Pending"}</p></td>
                                </tr>

                                <tr>
                                  <td>6</td>
                                  <td><b>Deduction u/s 80CCD(1)</b></td>
                                  <td>
                                    &nbsp;
                                  </td>
                                  <td>&nbsp;</td>
                                  <td>&nbsp;</td>
                                </tr>
                                <tr>
                                  <td></td>
                                  <td>Contribution To Pension Scheme of Central Government</td>
                                  <td>
                                    <div className="input-wrap width-30 margin0">
                                      <TextField disabled={this.state.readonlyInput}
                                        name="eightyCCCPensionSchemeCentral"
                                        id="eightyCCCPensionSchemeCentral"
                                        variant="filled"
                                        type="amount"
                                        value={this.state.investmentDeclarationForm.eightyCCCPensionSchemeCentral != undefined ? this.state.investmentDeclarationForm.eightyCCCPensionSchemeCentral : null}
                                        defaultValue={this.state.investmentDeclarationForm.eightyCCCPensionSchemeCentral != undefined ? this.state.investmentDeclarationForm.eightyCCCPensionSchemeCentral : null}
                                        onChange={(e) => this.onChangeInvestmentForm(e)}>
                                      </TextField>
                                    </div>
                                  </td>
                                  <td>
                                    {
                                      this.state.investmentFormData.eightyCCCPensionSchemeCentral != undefined && this.state.investmentFormData.eightyCCCPensionSchemeCentral.length > 0 ? <ul className="investment-doc-list-wrap">
                                        {this.state.investmentFormData.eightyCCCPensionSchemeCentral.map((item, i) => {
                                          return <li><span onClick={() => this.onDocDownload(item.url == undefined ? null : item.url)}>{item.name}</span> {item.url == undefined ? <span onClick={() => this.onRemoveDoc('eightyCCCPensionSchemeCentral', i)}>x</span> : null}</li>
                                        })}
                                      </ul> : null
                                    }
                                    <button className="add-item-btn " disabled={this.state.investmentDeclarationStatus == 'approved' ? false : true} onClick={() => this.showUploadUI('eightyCCCPensionSchemeCentral')} tooltip-title={"Upload"}><PublishSharpIcon className="material-addIcon" /></button></td>
                                  <td><p className={this.state.investmentFormData.eightyCCCPensionSchemeCentral != undefined && this.state.investmentFormData.eightyCCCPensionSchemeCentral.length > 0 ? "investment-status" : "investment-status-pending"}>{this.state.investmentFormData.eightyCCCPensionSchemeCentral != undefined && this.state.investmentFormData.eightyCCCPensionSchemeCentral.length > 0 ? "Done" : "Pending"}</p></td>
                                </tr>

                                <tr>
                                  <td>7</td>
                                  <td><b>Deduction u/s 80CCD(1B)</b></td>
                                  <td>
                                    &nbsp;
                                  </td>
                                  <td>&nbsp;</td>
                                  <td>&nbsp;</td>
                                </tr>
                                <tr>
                                  <td></td>
                                  <td>Contribution To National Pension Scheme</td>
                                  <td>
                                    <div className="input-wrap width-30 margin0">
                                      <TextField disabled={this.state.readonlyInput}
                                        name="eightyCCCPensionSchemeNational"
                                        id="eightyCCCPensionSchemeNational"
                                        variant="filled"
                                        type="amount"
                                        value={this.state.investmentDeclarationForm.eightyCCCPensionSchemeNational != undefined ? this.state.investmentDeclarationForm.eightyCCCPensionSchemeNational : null}
                                        defaultValue={this.state.investmentDeclarationForm.eightyCCCPensionSchemeNational != undefined ? this.state.investmentDeclarationForm.eightyCCCPensionSchemeNational : null}
                                        onChange={(e) => this.onChangeInvestmentForm(e)}>
                                      </TextField>
                                    </div>
                                  </td>
                                  <td>
                                    {
                                      this.state.investmentFormData.eightyCCCPensionSchemeNational != undefined && this.state.investmentFormData.eightyCCCPensionSchemeNational.length > 0 ? <ul className="investment-doc-list-wrap">
                                        {this.state.investmentFormData.eightyCCCPensionSchemeNational.map((item, i) => {
                                          return <li><span onClick={() => this.onDocDownload(item.url == undefined ? null : item.url)}>{item.name}</span> {item.url == undefined ? <span onClick={() => this.onRemoveDoc('eightyCCCPensionSchemeNational', i)}>x</span> : null}</li>
                                        })}
                                      </ul> : null
                                    }
                                    <button className="add-item-btn " disabled={this.state.investmentDeclarationStatus == 'approved' ? false : true} onClick={() => this.showUploadUI('eightyCCCPensionSchemeNational')} tooltip-title={"Upload"}><PublishSharpIcon className="material-addIcon" /></button></td>
                                  <td><p className={this.state.investmentFormData.eightyCCCPensionSchemeNational != undefined && this.state.investmentFormData.eightyCCCPensionSchemeNational.length > 0 ? "investment-status" : "investment-status-pending"}>{this.state.investmentFormData.eightyCCCPensionSchemeNational != undefined && this.state.investmentFormData.eightyCCCPensionSchemeNational.length > 0 ? "Done" : "Pending"}</p></td>
                                </tr>
                                <tr>
                                  <td>8</td>
                                  <td><b>Deduction u/s 80</b></td>
                                  <td>
                                    &nbsp;
                                  </td>
                                  <td>&nbsp;</td>
                                  <td>&nbsp;</td>
                                </tr>
                                {this.state.eightyDetails.length > 0 ?
                                  this.state.eightyDetails.map((ecItem, ecIndex) => {
                                    return <tr>
                                      <td></td>
                                      <td>
                                        <p style={{ float: "left", width: "5%" }}>{ecItem.section}</p>
                                        <div className="input-wrap merge-label-input margin0" style={{ float: "left", padding: "0" }}>
                                          <p className="input-label"></p>
                                          <TextField disabled={this.state.readonlyInput}
                                            name={ecItem.declaration}
                                            id={"declaration-" + ecIndex}
                                            variant="filled"
                                            type="text"
                                            defaultValue={ecItem.declaration != undefined ? ecItem.declaration : null}
                                            onBlur={(e) => this.onChangeDeclarationForm(e, ecIndex, 'declaration', 'eightyDetails')}>
                                          </TextField>
                                        </div>
                                      </td>
                                      <td>

                                        <div className="input-wrap width-30 margin0" style={{ width: "calc(70% - 15px)", marginRight: "15px", float: "left" }}>
                                          <TextField disabled={this.state.readonlyInput}
                                            name={ecItem.declaration + ' Amount'}
                                            id={"declaration-amount-" + ecIndex}
                                            variant="filled"
                                            type="number"
                                            defaultValue={ecItem.declarationAmount != undefined ? ecItem.declarationAmount : null}
                                            onBlur={(e) => this.onChangeDeclarationForm(e, ecIndex, 'declarationAmount', 'eightyDetails')}>
                                          </TextField>
                                        </div>
                                        {this.state.investmentDeclarationStatus != "approved" ? <div className="declaration-row-action" style={{ width: "30%", float: "left" }}>

                                          {this.state.eightyDetails.length == (Number(ecIndex) + 1) ? <IconButton onClick={(e) => this.onDeclarationRowAction(ecIndex, 'add', "eightyDetails")}>
                                            <AddCircleOutlineIcon />
                                          </IconButton> : null}
                                          <IconButton onClick={(e) => this.onDeclarationRowAction(ecIndex, 'delete', "eightyDetails")}> <RemoveCircleOutlineIcon />
                                          </IconButton>
                                        </div> : null}
                                      </td>
                                      <td>
                                        {
                                          this.state.investmentFormData[ecItem.declaration] != undefined && this.state.investmentFormData[ecItem.declaration].length > 0 ? <ul className="investment-doc-list-wrap">
                                            {this.state.investmentFormData[ecItem.declaration].map((item, i) => {
                                              return <li><span onClick={() => this.onDocDownload(item.url == undefined ? null : item.url)}>{item.name}</span> {item.url == undefined ? <span onClick={() => this.onRemoveDoc(ecItem.declaration, i)}>x</span> : null}</li>
                                            })}
                                          </ul> : null
                                        }
                                        <button className="add-item-btn " disabled={this.state.investmentDeclarationStatus == 'approved' ? false : true} onClick={() => this.showUploadUI(ecItem.declaration)} tooltip-title={"Upload"}><PublishSharpIcon className="material-addIcon" /></button></td>
                                      <td><p className={this.state.investmentFormData[ecItem.declaration] != undefined && this.state.investmentFormData[ecItem.declaration].length > 0 ? "investment-status" : "investment-status-pending"}>{this.state.investmentFormData[ecItem.declaration] != undefined && this.state.investmentFormData[ecItem.declaration].length > 0 ? "Done" : "Pending"}</p></td>
                                    </tr>
                                  }) : null}
                              </tbody>
                            </table>
                          </div>
                        </div>
                        <div className="verification-doc" style={{ backgroundColor: "#fff", border: "1px solid #dfe1e6", borderRadius: "3px" }}>
                          <p className="sub-navbar-title text-align-center mtb15"><i>Verification</i></p>
                          <p className="invoice-org-address1 verify-input-wrap"><p>I</p>
                            <div className="input-wrap verify-input">
                              <TextField disabled={this.state.readonlyInput}
                                name="nameOf"
                                id="nameOf"
                                variant="filled"
                                type="text"
                                value={this.state.investmentDeclarationForm.nameOf != undefined ? this.state.investmentDeclarationForm.nameOf : null}
                                defaultValue={this.state.investmentDeclarationForm.nameOf != undefined ? this.state.investmentDeclarationForm.nameOf : null}
                                onChange={(e) => this.onChangeInvestmentForm(e)}>
                              </TextField>
                            </div><p>,son/daughter of</p><div className="input-wrap verify-input">
                              <TextField disabled={this.state.readonlyInput}
                                name="investmentAmount"
                                id="investmentAmount"
                                variant="filled"
                                type="text"
                                value={this.state.investmentDeclarationForm.investmentAmount != undefined ? this.state.investmentDeclarationForm.investmentAmount : null}
                                defaultValue={this.state.investmentDeclarationForm.investmentAmount != undefined ? this.state.investmentDeclarationForm.investmentAmount : null}
                                onChange={(e) => this.onChangeInvestmentForm(e)}>
                              </TextField>
                            </div><p>do hereby certify that the information given above is completeand correct.</p>
                          </p>
                          <div className="dec-bottom-wrap" style={{ padding: "25px", backgroundColor: "#fff", border: "1px solid #dfe1e6", borderRadius: "3px", borderTop: "none" }}>
                            <div className="w50">
                              <div className="input-wrap">
                                <p className="input-label">Place</p>
                                <TextField disabled={this.state.readonlyInput}
                                  name="place"
                                  id="place"
                                  variant="filled"
                                  type="text"
                                  value={this.state.investmentDeclarationForm.place != undefined ? this.state.investmentDeclarationForm.place : null}
                                  defaultValue={this.state.investmentDeclarationForm.place != undefined ? this.state.investmentDeclarationForm.place : null}
                                  onChange={(e) => this.onChangeInvestmentForm(e)}>
                                </TextField>
                              </div>
                              <div className="input-wrap">
                                <p className="input-label">Date</p>
                                {/* <DatePicker disabled
                                  className="select-input-wrap date-wrap"
                                  format="DD-MM-YYYY"
                                  value={this.state.investmentDeclarationForm.date != undefined ? this.state.investmentDeclarationForm.date : null}
                                  defaultValue={this.state.investmentDeclarationForm.date != undefined ? this.state.investmentDeclarationForm.date : null}
                                  onChange={(e) => this.onChangeInvestmentForm(e)}
                                /> */}
                              </div>
                              <div className="input-wrap">
                                <p className="input-label">Designation</p>
                                <TextField disabled
                                  name="designation"
                                  id="designation"
                                  variant="filled"
                                  type="text"
                                  value={this.state.userDetails.designation != undefined ? this.state.userDetails.designation : null}
                                  defaultValue={this.state.userDetails.designation != undefined ? this.state.userDetails.designation : null}
                                  onChange={(e) => this.onChangeInvestmentForm(e)} readOnly>
                                </TextField>
                              </div>
                            </div>
                            <div className="w50 signature-wrap">
                              <p className="auth-sign-text">(Signature of the employee)</p>
                              <div className="input-wrap">
                                <p className="input-label">Full Name</p>
                                <TextField disabled={this.state.readonlyInput}
                                  name="fullName"
                                  id="fullName"
                                  variant="filled"
                                  type="text"
                                  value={this.state.investmentDeclarationForm.fullName != undefined ? this.state.investmentDeclarationForm.fullName : null}
                                  defaultValue={this.state.investmentDeclarationForm.fullName != undefined ? this.state.investmentDeclarationForm.fullName : null}
                                  onChange={(e) => this.onChangeInvestmentForm(e)}>
                                </TextField>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      : <div className="show-upload-main">
                        <div className="invoice-custom-table-wrapper invoice-extract-wrap" style={{ width: "100% !important" }}>
                          <div className="pdf-extract-wrap">
                            <div className="input-wrap" style={{ width: "25%", float: "left", paddingLeft: "1% !important" }}>
                              <p className="input-label">Password</p>
                              <TextField disabled={this.state.readonlyInput}
                                variant="filled"
                                type="password"
                                onChange={(e) => this.onInvestmentProofPwd(e)}
                                disabled={this.state.processLoaded == 0 ? true : false}
                                helperText={this.state.processLoaded == 0 ? "If you have document password, first upload the document after enter the password." : ""}
                              >
                              </TextField>
                            </div>
                            <button className="add-item-btn " style={{ float: "right" }} tooltip-title={"Submit"} onClick={() => this.onProofSubmission()}>SUBMIT</button>
                            <div className="onboard-card dot-card investment-dot-card" style={{ width: "100%", height: "calc(100vh - 31vh)", clear: "both" }} onClick={onButtonClick}>
                              {this.state.upload ?
                                <React.Fragment>
                                  {this.state.isPortal ?
                                    <div className="file-upload-wrap">
                                      <p className="file-process-hd" style={{ textAlign: 'center' }}>Fetching Data...</p>
                                    </div> :
                                    <div className="file-upload-wrap" onClick={(event) => { event.stopPropagation() }}>
                                      {this.state.pdfLoaded !== 100 ?
                                        <span className="file-loaded-percentage">{this.state.pdfLoaded}%</span>
                                        :
                                        <span className="file-loaded-percentage" style={{
                                          fontSize: '14px',
                                          color: "#00b8d9"
                                        }}><i class="fa fa-check" aria-hidden="true"></i></span>}
                                      <p className="file-process-hd">Uploading File({this.state.filename})</p>
                                      <LinearProgress color="primary" variant={"determinate"} value={this.state.pdfLoaded} />
                                      {this.state.processLoaded !== 100 ?
                                        <span className="file-loaded-percentage process-percentage">{this.state.processLoaded}%</span>
                                        :
                                        <span className="file-loaded-percentage process-percentage" style={{
                                          fontSize: '14px',
                                          color: "#00b8d9"
                                        }}><i class="fa fa-check" aria-hidden="true"></i></span>}
                                      <p className="file-process-hd">Processing File</p>
                                      <LinearProgress color="primary" variant={"determinate"} value={this.state.processLoaded < 75 ? this.state.processLoaded : 75} />
                                    </div>
                                  }
                                </React.Fragment>
                                : <div>
                                  <input type='file' id='file' disabled={this.state.pdfLoaded == 0 ? false : true} ref={this.inputFile} style={{ display: 'none' }} onChange={this.fileSelected} />
                                  <div className="card-third-round  " ><PublishOutlinedIcon className="onboard-icons" /> </div>
                                  <h6 className="onboard-card-header" style={{ textAlign: "center" }}>Upload Investment Proof PDF</h6>
                                  <p className="onboard-card-title" style={{ color: "#000", textAlign: "center" }} ><span className="browse-content" >Browse File</span> </p>

                                </div>}

                            </div>
                          </div>
                        </div>
                      </div>}
                  </div>

                  <Snackbar open={this.state.snackbar.openNotification} autoHideDuration={2000} onClose={this.closeNotification} anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}>
                    <Alert onClose={this.closeNotification}
                      severity={"info"}>
                      {this.state.snackbar.NotificationMessage}
                    </Alert>
                  </Snackbar>
                </div>

              }
            </React.Fragment>
          }

        </React.Fragment>}

      </React.Fragment >
    );
  }
}

export default MyInvestment;